import {
  forwardRef,
  type InputHTMLAttributes,
  type ReactNode,
  type TextareaHTMLAttributes,
} from "react"

import { cn } from "@/lib/utils"

// Labeled fields for the shell pages. The control chrome is the shared
// `.wfield-input` skin (aura-app.css) rather than Tailwind utilities —
// descendant rules like `.field input` out-specify utilities, which is the
// same reason the old floating-label component moved its chrome into CSS.
// The label always renders with htmlFor so getByLabelText / screen readers
// keep working, and the fragment form makes label + control direct grid
// children of the surrounding `.field` / `.wentry`.

export interface TextFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "id"> {
  id: string
  label: ReactNode
}

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ id, label, className, ...props }, ref) => (
    <>
      <label htmlFor={id}>{label}</label>
      <input ref={ref} id={id} className={cn("wfield-input", className)} {...props} />
    </>
  ),
)
TextField.displayName = "TextField"

export interface TextAreaFieldProps
  extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "id"> {
  id: string
  label: ReactNode
}

export const TextAreaField = forwardRef<HTMLTextAreaElement, TextAreaFieldProps>(
  ({ id, label, className, ...props }, ref) => (
    <>
      <label htmlFor={id}>{label}</label>
      <textarea ref={ref} id={id} className={cn("wfield-input", className)} {...props} />
    </>
  ),
)
TextAreaField.displayName = "TextAreaField"
